import { Box, Typography } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { getSeriesLabel } from '../../../../graph/chart-tooltip-utils';
import { TooltipData } from '../../../../graph/types';
import { YoutubeStatsTooltipSeriesHeader } from './YoutubeStatsTooltipSeriesHeader';
import { YoutubeStatsTooltipSeriesValue } from './YoutubeStatsTooltipSeriesValue';
import { YoutubeStatsTooltipTimestamp } from './YoutubeStatsTooltipTimestamp';

const openYoutubeAtThisMomentMessage = defineMessage({
  id: 'logger.youtubeStats.openYoutubeAtThisMoment',
  defaultMessage: 'Click para ir a YouTube en este momento',
});

type YoutubeStatsSingleTooltipProps = {
  data: TooltipData;
  channelThumbnailUrl?: string;
  videoTitle?: string;
  showYoutubeAction?: boolean;
};

/**
 * Single-line hover tooltip with channel stats and a click-through prompt to YouTube.
 */
export function YoutubeStatsSingleTooltip({
  data,
  channelThumbnailUrl,
  videoTitle,
  showYoutubeAction = false,
}: YoutubeStatsSingleTooltipProps) {
  const item = data.series[0];
  const label = getSeriesLabel(item.label);
  const color = typeof item.color === 'string' ? item.color : '#000';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <YoutubeStatsTooltipTimestamp timestamp={data.timestamp} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Box sx={{ flex: 1 }}>
          <YoutubeStatsTooltipSeriesHeader
            label={label}
            color={color}
            channelThumbnailUrl={channelThumbnailUrl}
            ribbonHeight={18}
            avatarSize={18}
          />
        </Box>
        <YoutubeStatsTooltipSeriesValue value={item.value} variant="body2" />
      </Box>
      {videoTitle ? (
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            color: 'grey.300',
            typography: 'overline',
            fontStyle: 'italic',
            lineHeight: 1.2,
          }}
        >
          {videoTitle}
        </Typography>
      ) : null}
      {showYoutubeAction ? (
        <Typography variant="caption" sx={{ display: 'block', lineHeight: 1.2, color: 'grey.300' }}>
          <FormattedMessage {...openYoutubeAtThisMomentMessage} />
        </Typography>
      ) : null}
    </Box>
  );
}
